import BaseModel from "../base/baseModel";

export default class CampanhaFaixaModel extends BaseModel {
    id?: number = null;
    valorInicial = 0;
    valorFinal = 0;
    valorPorPonto = 0;
    pontos = 0;
}
